import { render, staticRenderFns } from "./budgetComment.vue?vue&type=template&id=20b67594&scoped=true"
import script from "./budgetComment.vue?vue&type=script&lang=js"
export * from "./budgetComment.vue?vue&type=script&lang=js"
import style0 from "./budgetComment.vue?vue&type=style&index=0&id=20b67594&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b67594",
  null
  
)

export default component.exports